<template>
    <form class="edit-startdesk" v-bind:action="apiUrl + '/startdesks' + (id ? ('/' + id) : '')" v-on:submit.prevent="handleSubmit">
        <div class="edit-startdesk__cols has-margin-b5">
            <div class="edit-startdesk__col">
                <div class="form__group" v-bind:class="{ 'has-error' : errors.name }">
                    <label class="form__label" for="name">{{ __('Startdesk name') }}</label>
                    <input class="form__control is-large" id="name" type="text" autocomplete="off"
                           v-bind:placeholder="__('Enter startdesk name')"
                           v-model="name"
                    />
                    <span class="form__focus"></span>
                </div>
                <small class="form__error" v-if="errors.name">{{ errors.name[0] }}</small>

                <div class="form__group" v-if="user.is_admin">
                    <label class="form__label">{{ __('Category') }}</label>
                    <select class="form__control" v-bind:id="'category[' + index + ']'"
                            v-for="(categ, index) in selectedCategories"
                            v-model="selectedCategories[index]"
                            v-on:change="handleCategoryChange(index)"
                    >
                        <option v-for="cat in categories[index]" v-bind:value="cat.id">{{ cat.name }} ({{ cat.children.length }})</option>
                    </select>
                    <span class="form__focus"></span>
                </div>

                <div class="form__group">
                    <toggle v-bind:click="toggleVisibleToUser"
                            label="Show startdesk in sidebar menu"
                            v-model="isVisibleToUser" />
                </div>

                <div class="form__group">
                    <toggle v-bind:click="togglePrivate"
                            label="Public startdesk"
                            v-model="isPublic" />
                </div>
            </div>

            <div class="edit-startdesk__col">
                <div class="form is-horizontal">
                    <div class="form__group">
                        <div class="edit-startdesk__image">
                            <label class="form__label">{{ __('Background image') }}</label>
                            <img v-bind:src="image" v-if="image"/>
                            <div class="edit-startdesk__preview" v-bind:style="backgroundProperty" v-if="!image" ></div>
                            <a class="btn is-danger edit-startdesk__remove-image-btn"  v-if="image" v-on:click="removeImage">{{ __('Remove image') }}</a>
                        </div>
                        <file-control accept="image/*" v-bind:label="''" v-model="image" />
                    </div>
                    <color-picker v-bind:label="__('Background color')" v-model="backgroundColor" ref="backgroundColorRef" />
                </div>
            </div>
        </div>

        <span class="view__separator has-margin-t0">
            <span>{{ __('or choose existing background image') }}</span>
        </span>

        <wallpaper-list list-type="add"
                v-bind:selectable="true"
                v-bind:show-filters="{ 'category': true }"
                v-bind:show-paging="true"
                v-bind:show-title="false"
        />

        <button class="btn is-primary edit-startdesk__save-btn" type="submit">{{ __('Save') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import wallpaperList from './WallpaperList.vue';
    import colorPicker from '../elements/ColorPicker.vue';
    import fileControl from '../elements/FileControl.vue';
    import toggle from '../elements//Toggle';

    export default {
        components: {
            colorPicker,
            fileControl,
            wallpaperList,
            toggle
        },
        computed: {
            backgroundProperty: function () {
                let background =  'background-color: ' + this.backgroundColor.hex + ';';

                if (this.selectedWallpaper) {
                    background += 'background-image: url(/media/wallpapers/thumbs/' + this.selectedWallpaper + ');';
                }
                return background;
            }
        },
        data: function () {
            return {
                backgroundColor: {
                    hex: '#f0f3fa',
                    hsl: { h: 222, s: 0.04, l:.98, a: 1 },
                    hsv: { h: 240, s: 0, v: .98, a: 1 },
                    rgba: { r: 240, g: 243, b: 250, a: 1 },
                    a: 1
                },
                categories: [],
                category: null,
                categoryHierarchy: [],
                errors: {},
                image: '',
                name: '',
                isPublic: true,
                isVisibleToUser: true,
                selectedCategories: [],
                selectedWallpaper: ''
            }
        },
        methods: {
            getCategories: function (cat, index) {
                var parent = cat;
                if (typeof parent == 'undefined') {
                    parent = '';
                }

                if (typeof index == 'undefined') {
                    index = 0;
                }

                this.$delete(this.categories, index);

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/startdesks/categories', {
                    params : {
                        page: 1,
                        filters: {
                            parent: parent
                        },
                        perPage: 0,
                        sortBy: 'name',
                        sortOrder: 'asc'
                    }
                }).then(function (response) {
                    this.$set(this.categories, index, response.body.original.data);
                    if (this.categories[index].length > 0 && typeof this.selectedCategories[index] == 'undefined') {
                        this.$set(this.selectedCategories, index, '');
                    }

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            getStartdesk: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/startdesks/' + this.id).then(function (response) {
                    const startdesk = response.body;

                    if (startdesk.user_id != this.user.id && !this.user.is_admin) {
                        this.$router.push({
                            name: 'home'
                        });
                    }


                    this.name = startdesk.name;
                    this.category = startdesk.category_id;
                    this.categoryHierarchy = startdesk.category_hierarchy;
                    this.isPublic = !startdesk.is_private;
                    this.isVisibleToUser = startdesk.is_visible_to_user;

                    if (this.categoryHierarchy.length > 0) {
                        this.categoryHierarchy.forEach(function(cat, index) {
                            this.getCategories(cat.parent_id, index);
                            this.selectedCategories[index] = cat.id;

                            this.getCategories(cat, index + 1);
                        }.bind(this));
                    }

                    if (startdesk.background_color) {
                        this.backgroundColor = { hex: startdesk.background_color };
                        this.$refs.backgroundColorRef.color = this.backgroundColor;
                    }

                    if (startdesk.background_image) {
                        this.image = '/media/wallpapers/' + startdesk.background_image;
                    }

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleCategoryChange: function (index) {
                for (let i = index + 1; i < this.categories.length; i++) {
                    this.$delete(this.categories, i);
                    this.$delete(this.selectedCategories, i);
                }
                this.getCategories(this.selectedCategories[index], index + 1);
                this.category = this.selectedCategories[index];
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');
                const method = this.id ? 'patch' : 'post';

                eventBus.$emit('show-loader');

                let payload = {
                    background_color: this.backgroundColor.hex,
                    background_image: this.image.replace('/media/wallpapers/', ''),
                    name: this.name,
                    user_id: this.user.id,
                    wallpaper_image: this.selectedWallpaper,
                    is_private: !this.isPublic,
                    is_visible_to_user: this.isVisibleToUser,
                };

                if (this.category) {
                    payload.category_id = this.category;
                }

                if (!this.id && this.user.is_admin) {
                    payload.visible_to_user = 0;
                }

                this.$http[method](action, payload).then(function (response) {
                    eventBus.$emit('hide-loader');

                    if (this.id) {
                        this.myStartdesks.forEach(function(myStartdesk) {
                            if (myStartdesk.id == this.id) {
                                myStartdesk.name = this.name;
                                myStartdesk.background_image = response.body.background_image;
                                myStartdesk.is_private = !this.isPublic;
                                myStartdesk.is_visible_to_user = this.isVisibleToUser;
                            }
                        }.bind(this));
                    
                        this.myStartdesks.sort(function(a, b) {
                            return  a.name.localeCompare(b.name);
                        });

                        if (this.activeStartdesk && this.activeStartdesk.id == this.id) {
                            this.activeStartdesk.name = this.name;
                            this.activeStartdesk.background_image = response.body.background_image
                            this.activeStartdesk.is_private = !this.isPublic;
                            this.activeStartdesk.is_visible_to_user = this.isVisibleToUser;
                        }
                    } else {
                        this.myStartdesks.push(response.body);

                        this.myStartdesks.sort(function(a, b) {
                            return  a.name.localeCompare(b.name);
                        });
                    }

                    this.changeStartdesk(response.body);

                    this.$http.post(this.apiUrl + '/startdesks/' + response.body.id + '/screenshot');


                    eventBus.$emit('show-alert', 'success', this.__('Startdesk has been successfully saved.'));

                    this.$router.push({
                        name: 'startdesks.view',
                        params: { startdesk: this.activeStartdesk.slug, u: this.activeStartdesk.is_user_startdesk }
                    });
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                });
            },
            togglePrivate: function () {
                this.isPublic = !this.isPublic;
            },
            toggleVisibleToUser: function () {
                this.isVisibleToUser = !this.isVisibleToUser;
            },
            init: function () {
                if (this.id) {
                    this.getStartdesk();
                }

                if (this.user.is_admin) {
                    this.getCategories();
                }
            },
            removeImage: function () {
                this.image = '';
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            id: {
                default: null,
                type: Number
            }
        },
        watch: {
            selectedWallpaper: function () {
                this.image = '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/EditStartdesk.vue